import { useMemo } from 'react'

import { CustomFieldType } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

interface Props {
  id: string
  slug: string
  excludeRichText?: boolean
}
export const useCustomFields = ({
  id,
  slug,
  excludeRichText = true,
}: Props) => {
  const {
    data: { postTypes },
  } = useNetwork()

  let postTypeId = id
  let postTypeSlug = slug

  // Make the component backward compatible
  if (slug) {
    postTypeId = postTypes?.find(postType => postType.slug === slug)?.id ?? id
  } else if (id) {
    postTypeSlug =
      postTypes?.find(postType => postType.id === postTypeId)?.slug ?? slug
  }

  const postType = useMemo(
    () => postTypes?.find(postType => postType.id === postTypeId),
    [postTypeId, postTypes],
  )
  const customFields = useMemo(() => {
    return postType?.postFields?.fields?.filter(
      field =>
        !field?.archived &&
        !(excludeRichText && field.type === CustomFieldType.richText),
    )
  }, [excludeRichText, postType?.postFields?.fields])

  return { customFields, postType, postTypes, postTypeSlug, postTypeId }
}
